import { Trash2, Edit, Eye } from "feather-icons-react/build/IconComponents";
import React, { useEffect, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Brand from "../../../core/modals/inventory/brand";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import { all_routes } from "../../../Router/all_routes";
import CommonMaterialReactTable from "../../MaterialReactTable/CommonMaterialReactTable";
import apiHandler from "../../common/api";
import { Box } from "@mui/material";
import "sweetalert2/dist/sweetalert2.min.css";
import HeaderModule from "../../components/Header/HeaderModule";
import { useSelector } from "react-redux";


const ServiceList = () => {
  // const dispatch = useDispatch();
  // const data = useSelector((state) => state.toggle_header);
  const navigate = useNavigate();
  const user_data = useSelector((state) => state.user_data);
  const [productlist, setProductlist] = useState([]);

  const [deletes, setdelete] = useState(false);
  console.log(user_data?.businessUniqueName,"lapidartist");
  
    const handleDelete = async (id) => {
    //console.log(id, "delete");

    let reqobj = {
      ID: id,
      Module: "priceAndDurationService",
    };
    const response = await apiHandler({
      method: "POST",
      route: "Superadmin/deletebymoduleid",
      payload: reqobj,
    });
    if (response.ResponseCode === "SUCCESS") {
      fetchServiceData();
      console.log(response, "data");
      setdelete(!deletes);
    } else {
      console.log(response, "data");
    }
  };

  const MySwal = withReactContent(Swal);
  const showConfirmationAlert = (ID) => {
    MySwal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      showCancelButton: true,
      confirmButtonColor: "#00ff00",
      confirmButtonText: "Yes, delete it!",
      cancelButtonColor: "#ff0000",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        handleDelete(ID)
        MySwal.fire({
          title: "Deleted!",
          text: "Your service has been deleted.",
          className: "btn btn-success",
          confirmButtonText: "OK",
          customClass: {
            confirmButton: "btn btn-success",
          },
        });
      } else {
        MySwal.close();
      }
    });
  };


  const columns = [
    {
      header: "ID",
      accessorKey: "serviceId",
      enableSorting: true,
      sortingFn: "alphanumeric",
    },
    {
      header: "Service Name",
      accessorKey: "name",
      enableSorting: true,
      sortingFn: "alphanumeric",
    },
    {
      header: "Category",
      accessorKey: "category",
      enableSorting: true,
      sortingFn: "alphanumeric",
    },
    {
      header: "MIN Duration",
      accessorKey: "minduration",
      enableSorting: true,
      sortingFn: "alphanumeric",
    },
      {
      header: "MAX Duration",
      accessorKey: "maxduration",
      enableSorting: true,
      sortingFn: "alphanumeric",
    },
    {
      header: "Price",
      accessorKey: "price",
      enableSorting: true,
      sortingFn: "alphanumeric",
      Cell: ({ row }) => (
       ` $${Number(row.original.price).toFixed(2)}`
      )
    },
    {
      accessorKey: "actions",
      header: "Actions",
      enableSorting: false,
      enableColumnFilter: false,
      Cell: ({ row }) => (
        <Box sx={{ display: "flex", gap: "0.5rem" }}>
          <button
           className="btn btn-outline-primary btn-sm me-2"
            // color="primary"
            onClick={() => {
              navigate(`${route.ManageService}/${row.original.serviceId}`);
            }}
          >
            <Edit  className='custome-icon-size' />
          </button>

          <button
           className="btn btn-outline-primary btn-sm me-2"
            // color="primary"
            onClick={() => {
              navigate(`/servicelistview/${row.original.serviceId}`);
              // navigate(`${route.BusinessOnboarding}/${row.original.ID}`);
            }}
          >
            <Eye  className='custome-icon-size' />
          </button>

          <button
           className="btn btn-outline-primary btn-sm me-2"
            // color="error"
            onClick={() => {
              showConfirmationAlert(row.original.PriceID)
            }}
          >
            <Trash2  className='custome-icon-size' />
          </button>
        </Box>
      ),
    },
  ];

  const route = all_routes;

  const fetchServiceData = async () => {
    try {
      const serviceData = await apiHandler({
        method: "GET",
        route: `Business/TeamserviceData?BusinessID=${user_data.businessId}`,
      });

      if (serviceData?.ResponseCode !== "SUCCESS") {
        console.error("Failed to fetch team list:", serviceData);
        return;
      }

      setProductlist(serviceData?.ResponseData);
    } catch (error) {
      console.error("Error fetching service data:", error);
    }
  };

  useEffect(() => {
    fetchServiceData();
  }, []);

  const exportData = productlist.map((item) => ({
    ID: item?.serviceId,
    ServiceName: item?.name,
    Category: item?.category,
  }));

  

  return (
    <div className="page-wrapper">
      <div className="content">
        <HeaderModule
          refreshData={fetchServiceData}
          exportData={exportData}
          addMasterPageLink={route.ManageService}
        />
        {/* /product list */}
        <div className="card table-list-card">
          <div className="card-body">
            <div className="table-responsive">
              <CommonMaterialReactTable columns={columns} data={productlist} />
            </div>
          </div>
        </div>
        {/* /product list */}
        <Brand />
      </div>
    </div>
  );
};

export default ServiceList;

// <div className="page-header">
// <div className="add-item d-flex">
//   <div className="page-title">
//     <h4>Service List</h4>
//     <h6>Manage your Service</h6>
//   </div>
// </div>
// <ul className="table-top-head">
//   <li>
//     <OverlayTrigger placement="top" overlay={renderTooltip}>
//       <Link>
//         <ImageWithBasePath src="assets/img/icons/pdf.svg" alt="img" />
//       </Link>
//     </OverlayTrigger>
//   </li>
//   <li>
//     <OverlayTrigger placement="top" overlay={renderExcelTooltip}>
//       <Link data-bs-toggle="tooltip" data-bs-placement="top">
//         <ImageWithBasePath
//           src="assets/img/icons/excel.svg"
//           alt="img"
//           onClick={() => {
//             showConfirmationAlert();
//           }}
//         />
//       </Link>
//     </OverlayTrigger>
//   </li>
//   <li>
//     <OverlayTrigger placement="top" overlay={renderPrinterTooltip}>
//       <Link data-bs-toggle="tooltip" data-bs-placement="top">
//         <i data-feather="printer" className="feather-printer" />
//       </Link>
//     </OverlayTrigger>
//   </li>
//   <li>
//     <OverlayTrigger
//       placement="top"
//       overlay={renderRefreshTooltip}
//       onClick={fetchServiceData}
//     >
//       <Link data-bs-toggle="tooltip" data-bs-placement="top">
//         <RotateCcw />
//       </Link>
//     </OverlayTrigger>
//   </li>
//   <li>
//     <OverlayTrigger placement="top" overlay={renderCollapseTooltip}>
//       <Link
//         data-bs-toggle="tooltip"
//         data-bs-placement="top"
//         id="collapse-header"
//         className={data ? "active" : ""}
//         onClick={(e) => {
//           e.preventDefault();
//           dispatch(setToogleHeader(!data));
//         }}
//       >
//         <ChevronUp />
//       </Link>
//     </OverlayTrigger>
//   </li>
// </ul>
// {useCheckUserPermission(route.ManageService) && (
//   <div className="page-btn">
//     <Link to={route.ManageService} className="btn btn-added">
//       <PlusCircle className="me-2 iconsize" />
//       Add Service
//     </Link>
//   </div>
// )}
// {/* {useCheckUserPermission(route.AddStaff) && (
//   <div className="page-btn">
//     <Link to={route.AddStaff} className="btn btn-added">
//       <PlusCircle className="me-2 iconsize" />
//       Add Team
//     </Link>
//   </div>
// )} */}
// </div>











  //  const handleDownload = () => {
  //   // Define headers
  //   const headers = [
  //     ["Service Name", "Business ID", "Service Type ID", "Menu Category ID", "Duration", "Price Type", "Price", "Staff Commission"]
  //   ];

  //   // Create a worksheet
  //   const worksheet = XLSX.utils.aoa_to_sheet(headers);

  //   // Create a new workbook and append the worksheet
  //   const workbook = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(workbook, worksheet, "Services");

  //   // Generate Excel file buffer
  //   const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });

  //   // Save file
  //   const data = new Blob([excelBuffer], { type: "application/octet-stream" });
  //   saveAs(data, "Services_Template.xlsx");
  // };

